import { render, staticRenderFns } from "./MyResponses.vue?vue&type=template&id=666aab08&scoped=true"
import script from "./MyResponses.vue?vue&type=script&lang=js"
export * from "./MyResponses.vue?vue&type=script&lang=js"
import style0 from "./MyResponses.vue?vue&type=style&index=0&id=666aab08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666aab08",
  null
  
)

export default component.exports